export const resources = {
  tr: {
    translation: {
      app: {
        homeAriaLabel: "Bilgili Karaoke ana sayfa",
      },
      language: {
        label: "Dil",
        turkish: "Türkçe",
        english: "English",
        changeError: "Dil değiştirilemedi",
      },
      notifications: {
        region: "Bildirimler",
        close: "Bildirimi kapat",
        addedToPlaylist: "{{playlist}} listesine eklendi",
        removedFromPlaylist: "{{playlist}} listesinden kaldırıldı",
      },
      urlForm: {
        label: "YouTube URL'si",
        invalidHint:
          "Herkese açık bir youtube.com/watch, youtube.com/shorts/ veya youtu.be URL'si kullanın.",
        submit: "Karaoke oluştur",
        languageLabel: "Şarkı sözleri dili",
        languageOption: {
          tr: "Türkçe",
        },
        paste: "Yapıştır",
        pasteAriaLabel: "Panodan yapıştır",
      },
      home: {
        errors: {
          fetchPlaylists: "Çalma listeleri yüklenemedi",
          createJob: "Şarkı hazırlanamadı",
          addSong: "Şarkı çalma listesine eklenemedi",
          removeSong: "Şarkı çalma listesinden kaldırılamadı",
          pollJob: "Şarkının hazırlanma durumu alınamadı",
        },
      },
      playlistActions: {
        inPlaylist: "{{playlist}} içinde",
        addingPlaylist: "{{playlist}} ekleniyor",
        addToPlaylist: "{{playlist}} listesine ekle",
      },
      progress: {
        heading: "Karaoke hazırlanıyor",
        statuses: {
          completed: "Tamamlandı",
          failed: "Başarısız",
          cancelled: "İptal edildi",
          idle: "Hazır",
        },
        working: "hazırlanıyor...",
        stages: {
          validating: "URL doğrulanıyor",
          extractingAudio: "Ses dosyası hazırlanıyor",
          separatingAudio: "Vokal ve Melodi ayrılıyor",
          compressingStems: "Ses dosyaları sıkıştırılıyor",
          transcribing: "Sözler çıkarılıyor",
          generatingSubtitles: "Karaoke sözleri hazırlanıyor",
        },
      },
      recent: {
        heading: "Son eklenenler",
        empty: "Son şarkı yok.",
        searchLabel: "Şarkı ara",
        searchPlaceholder: "Başlığa göre ara",
        resultsStatus: "Eşleşen şarkı sayısı: {{count}}",
        emptySearch: "Aramanızla eşleşen şarkı yok.",
        paginationLabel: "Son eklenenler sayfaları",
        previousPage: "Önceki",
        nextPage: "Sonraki",
        pageStatus: "{{current}} / {{total}}",
        goToPage: "{{page}} numaralı sayfaya git",
      },
      songPage: {
        back: "Geri",
        loading: "Şarkı yükleniyor...",
        loadError: "Şarkı yüklenemedi",
        stemUnavailable:
          "Bu şarkının ayrı vokal ve Melodi dosyaları artık mevcut değil.",
        instrumentalLabel: "Melodi",
        vocalsLabel: "Vokal",
        play: "Oynat",
        pause: "Duraklat",
        mute: "Sustur",
        unmute: "Sesi aç",
        statusMuted: "Susturuldu",
        statusAudible: "Aktif",
        muteAria: "{{stem}} parçasını sustur",
        unmuteAria: "{{stem}} parçasının sesini aç",
        seekLabel: "Şarkı içinde konum",
        subtitlesAria: "Şarkı sözleri",
        subtitlesIdle: "Müzik çaldığında sözler burada görünür.",
        addToPlaylistHeading: "Bir çalma listesine ekle",
        playerLoading: "Oynatıcı hazırlanıyor...",
        playerError: "Oynatıcı yüklenemedi",
        playerTimeoutError: "Oynatıcı zaman aşımına uğradı. Yeniden deneyin.",
        playerRetry: "Yeniden dene",
        buffering: "Yükleniyor",
      },
      playlists: {
        heading: "Çalma listeleri",
        tablistLabel: "Çalma listeleri",
        emptyPlaylists: "Henüz çalma listesi yok.",
        emptySongs: "Bu listede şarkı yok.",
        remove: "Kaldır",
        confirm: "Onayla",
        cancel: "İptal",
      },
      homeLibrary: {
        tablistLabel: "Kütüphane bölümleri",
        tabs: {
          playlists: "Çalma listeleri",
          recent: "Kareoke Müzikleri",
        },
      },
      admin: {
        loading: "Yönetim ekranı yükleniyor...",
        logout: "Çıkış",
        sessionExpires: "Oturum bitiş zamanı: {{expires}}",
        login: {
          heading: "Yönetici girişi",
          password: "Şifre",
          submit: "Giriş yap",
        },
        tabs: {
          label: "Yönetim bölümleri",
          overview: "Özet",
          jobs: "Hazırlanan şarkılar",
          library: "Kütüphane",
          users: "Kullanıcılar",
          settings: "Ayarlar",
        },
        overview: {
          recentJobs: "Son hazırlananlar",
        },
        jobs: {
          search: "Şarkı kaydı ara",
          searchButton: "Ara",
          cancel: "İptal et",
          openSong: "Şarkıyı aç",
          none: "Şarkı kaydı seçilmedi.",
          created: "Şarkı kaydı oluşturuldu",
          cancelled: "Şarkı hazırlama iptal edildi",
          delete: "Kaydı sil",
          deleteConfirm:
            "Bu kaydı kalıcı olarak silmek istiyor musunuz? Veritabanı kaydı, hazırlama adımları, çalma listesi bağlantıları ve saklanan ses dosyaları silinecek.",
          deleted: "Kayıt silindi",
          deleteNonTerminal: "Silmeden önce hazırlamayı iptal edin.",
        },
        library: {
          deleteSong: "Şarkıyı sil",
          deleteSongConfirm:
            "Bu şarkıyı kalıcı olarak silmek istiyor musunuz? Tüm çalma listelerinden kaldırılacak.",
          songDeleted: "Şarkı silindi",
        },
        users: {
          system: "Sistem kullanıcısı",
          jobCount: "Şarkı sayısı: {{count}}",
        },
        settings: {
          maxDuration: "Azami süre (saniye)",
          lineChars: "Satır karakter sınırı",
          lineWords: "Satır kelime sınırı",
          lineMinWords: "Asgari satır kelime sayısı",
          metadata: "Bilgi alma hizmeti",
          audio: "Ses hazırlama hizmeti",
          separation: "Ses ayırma hizmeti",
          transcription: "Söz çıkarma hizmeti",
          subtitles: "Altyazı hazırlama hizmeti",
          splitter: "LALAL.AI ayırma modeli",
          deepgramModel: "Deepgram modeli",
          wordHighlighting: "Kelime vurgusu",
          dereverb: "Yankı azaltma",
          credentials: "Deepgram: {{deepgram}} · LALAL.AI: {{lalalai}}",
          configured: "tanımlı",
          missing: "eksik",
          save: "Ayarları kaydet",
          saved: "Ayarlar kaydedildi",
        },
        errors: {
          login: "Yönetici girişi başarısız",
          logout: "Çıkış yapılamadı",
          createJob: "Yönetim ekranından şarkı hazırlanamadı",
          loadJob: "Şarkı kaydı yüklenemedi",
          cancelJob: "Şarkı hazırlama iptal edilemedi",
          deleteJob: "Kayıt silinemedi",
          deleteSong: "Şarkı silinemedi",
          saveSettings: "Ayarlar kaydedilemedi",
        },
      },
      footer: {
        rights:
          "Bu platform DRM, yaş sınırları, özel videolar veya ödeme duvarlarını aşmaz. Yalnızca işleme hakkına sahip olduğunuz içerikleri gönderin.",
      },
    },
  },
  en: {
    translation: {
      app: {
        homeAriaLabel: "Bilgili Karaoke home",
      },
      language: {
        label: "Language",
        turkish: "Türkçe",
        english: "English",
        changeError: "Unable to change language",
      },
      notifications: {
        region: "Notifications",
        close: "Dismiss notification",
        addedToPlaylist: "Added to {{playlist}}",
        removedFromPlaylist: "Removed from {{playlist}}",
      },
      urlForm: {
        label: "YouTube URL",
        invalidHint:
          "Use a public youtube.com/watch, youtube.com/shorts/, or youtu.be URL.",
        submit: "Generate karaoke",
        languageLabel: "Lyrics language",
        languageOption: {
          tr: "Turkish",
        },
        paste: "Paste",
        pasteAriaLabel: "Paste from clipboard",
      },
      home: {
        errors: {
          fetchPlaylists: "Unable to fetch playlists",
          createJob: "Unable to create job",
          addSong: "Unable to add song to playlist",
          removeSong: "Unable to remove song from playlist",
          pollJob: "Failed to poll job status",
        },
      },
      playlistActions: {
        inPlaylist: "In {{playlist}}",
        addingPlaylist: "Adding {{playlist}}",
        addToPlaylist: "Add to {{playlist}}",
      },
      progress: {
        heading: "Preparing Karaoke",
        statuses: {
          completed: "Completed",
          failed: "Failed",
          cancelled: "Cancelled",
          idle: "Idle",
        },
        working: "working...",
        stages: {
          validating: "Validating URL",
          extractingAudio: "Extracting audio",
          separatingAudio: "Separating vocals and instrumental",
          compressingStems: "Compressing stems",
          transcribing: "Transcribing vocals",
          generatingSubtitles: "Generating karaoke subtitles",
        },
      },
      recent: {
        heading: "Recent",
        empty: "No recent songs.",
        searchLabel: "Search songs",
        searchPlaceholder: "Search by title",
        resultsStatus: "Matching songs: {{count}}",
        emptySearch: "No songs match your search.",
        paginationLabel: "Recent song pages",
        previousPage: "Previous",
        nextPage: "Next",
        pageStatus: "{{current}} / {{total}}",
        goToPage: "Go to page {{page}}",
      },
      songPage: {
        back: "Back",
        loading: "Loading song...",
        loadError: "Unable to load song",
        stemUnavailable:
          "Separate vocal/instrumental stems are no longer available for this song.",
        instrumentalLabel: "Instrumental",
        vocalsLabel: "Vocals",
        play: "Play",
        pause: "Pause",
        mute: "Mute",
        unmute: "Unmute",
        statusMuted: "Muted",
        statusAudible: "Audible",
        muteAria: "Mute {{stem}}",
        unmuteAria: "Unmute {{stem}}",
        seekLabel: "Playback position",
        subtitlesAria: "Lyrics",
        subtitlesIdle: "Lyrics appear here while the song plays.",
        addToPlaylistHeading: "Add to a playlist",
        playerLoading: "Preparing player...",
        playerError: "Unable to load player",
        playerTimeoutError: "The player timed out. Try again.",
        playerRetry: "Try again",
        buffering: "Buffering",
      },
      playlists: {
        heading: "Playlists",
        tablistLabel: "Playlists",
        emptyPlaylists: "No playlists.",
        emptySongs: "No songs.",
        remove: "Remove",
        confirm: "Confirm",
        cancel: "Cancel",
      },
      homeLibrary: {
        tablistLabel: "Library sections",
        tabs: {
          playlists: "Playlists",
          recent: "Karaoke Songs",
        },
      },
      admin: {
        loading: "Loading admin...",
        logout: "Log out",
        sessionExpires: "Session expires: {{expires}}",
        login: {
          heading: "Admin login",
          password: "Password",
          submit: "Log in",
        },
        tabs: {
          label: "Admin sections",
          overview: "Overview",
          jobs: "Jobs",
          library: "Library",
          users: "Users",
          settings: "Settings",
        },
        overview: {
          recentJobs: "Recent jobs",
        },
        jobs: {
          search: "Search jobs",
          searchButton: "Search",
          cancel: "Cancel",
          openSong: "Open song",
          none: "No job selected.",
          created: "Job created",
          cancelled: "Job cancelled",
          delete: "Delete job",
          deleteConfirm:
            "Delete this job permanently? This removes its database row, pipeline steps, playlist membership and stored audio.",
          deleted: "Job deleted",
          deleteNonTerminal: "Cancel the job before deleting it.",
        },
        library: {
          deleteSong: "Delete song",
          deleteSongConfirm:
            "Delete this song permanently? It will disappear from every playlist.",
          songDeleted: "Song deleted",
        },
        users: {
          system: "System user",
          jobCount: "Job count: {{count}}",
        },
        settings: {
          maxDuration: "Maximum duration (seconds)",
          lineChars: "Line character limit",
          lineWords: "Line word limit",
          lineMinWords: "Minimum words per line",
          metadata: "Metadata provider",
          audio: "Audio extraction provider",
          separation: "Separation provider",
          transcription: "Transcription provider",
          subtitles: "Subtitle provider",
          splitter: "LALAL.AI splitter",
          deepgramModel: "Deepgram model",
          wordHighlighting: "Word highlighting",
          dereverb: "Dereverb",
          credentials: "Deepgram: {{deepgram}} · LALAL.AI: {{lalalai}}",
          configured: "configured",
          missing: "missing",
          save: "Save settings",
          saved: "Settings saved",
        },
        errors: {
          login: "Admin login failed",
          logout: "Unable to log out",
          createJob: "Unable to create admin job",
          loadJob: "Unable to load job",
          cancelJob: "Unable to cancel job",
          deleteJob: "Unable to delete job",
          deleteSong: "Unable to delete song",
          saveSettings: "Unable to save settings",
        },
      },
      footer: {
        rights:
          "This platform does not bypass DRM, age gates, private videos, or paywalls. Only submit content you have the rights to process.",
      },
    },
  },
} as const;

export type SupportedLanguage = keyof typeof resources;
